import React from 'react'
import Row from '@amzn/meridian/row'
import Text from '@amzn/meridian/text'
import Badge from '@amzn/meridian/badge'
import Button from '@amzn/meridian/button'
import Icon from '@amzn/meridian/icon'
import chevronLeftSmallTokens from '@amzn/meridian-tokens/base/icon/chevron-left-small'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import { BACK } from '../constants'

interface ISectionHeaderProps {
    title: string
    count?: number
}

/** Underlined section title with an optional count badge ("Needs immediate attention  4"). */
export const SectionHeader: React.FC<ISectionHeaderProps> = ({ title, count }) => (
    <div className="action-center-section-header" data-testid="section-header">
        <Row alignmentVertical="center" widths={['fill', 'fit']}>
            <Text type="h200">{title}</Text>
            {typeof count === 'number' && count > 0 && <Badge type="theme" value={count} data-testid="section-count" />}
        </Row>
    </div>
)

interface IBackHeaderProps {
    onBack: () => void
    title?: string
}

/** "< Back" row used by the category list and the detail view. */
export const BackHeader: React.FC<IBackHeaderProps> = ({ onBack, title }) => {
    const [bundle] = useBundle(BUNDLE_NAME)
    return (
        <div className="action-center-back-header">
            <Row alignmentVertical="center" spacing="200" widths={['fit', 'fill']}>
                <Button type="link" size="small" onClick={onBack} data-testid="back-button">
                    <Icon tokens={chevronLeftSmallTokens} />
                    {t(bundle, BACK)}
                </Button>
                {title && <Text type="h200">{title}</Text>}
            </Row>
        </div>
    )
}
